import React from "react";
import { locked } from "../../images";

const ModuleLocked = (props) => {
  return (
    <div className="m-1">
      {props.isLocked ? (
        <div onClick={props.Unlock}>
          <img alt="Locked" height="20" src={locked} />
        </div>
      ) : (
        <div />
        // <div onClick={props.Lock}>
        //   <img alt="Live" height="20" src={unlocked} />
        // </div>
      )}
    </div>
  );
};

export default ModuleLocked;
